// Localization file, segregated based on game name.
// *** NOTE ***
// Those general info are used across different games
// should always maintained in general object to prevent
// double info. Please refer en.js as full example.

const vi = {
  general: {
    wallet: "Số Dư",
    menulogout: "HOME",// "Đăng xuất",
    goodroad: "Dragon Alert",
    menufavourite: "Favourite",
    favouritegame: "Favourite Game",
    availablegame: "Available Game",
    menusfx: "Âm thanh",
    menuon: "BẬT",
    menuoff: "TẮT",
    menurules: "Luật chơi",
    menuresult: "Kết quả",
    menustatement: "Sao kê",
    menunotification: "Thông báo",
    menuviewhistory: "Xem lịch sử",
    menufullscreen: "Toàn màn hình",
    marketclosed: "Thị trường đã đóng",
    menutrend: "Xu hướng",
    menusimple: "Đơn giản",
    menunormal: "Bình thường",

    draw_no: "Vòng Số.",
    rebet: "Cược lại",
    no_more_bet: "Ngừng nhận cược",
    sum: "TỔNG",
    next_draw: "VÒNG CƯỢC TIẾP THEO",
    last_bets_for: "Cược gần nhất vào",
    bet_total: "Tổng Cược",
    no_bets_last_round: "Không có cược cho vòng trước.",
    max: "Tối đa",
    payout: "Trả thưởng",
    min_to: "Tối thiểu",
    max_to: "Tối đa",
    cancel: "Hủy",
    bet: "Đặt cược",
    ref: "Số tham chiếu",
    gap: "KHOẢNG CÁCH",
    confirm: "Confirm",

    sum_bs_short: "Tổng T/X",
    sum_oe_short: "Tổng L/C",
    Big: "Tài",
    Small: "Xỉu",
    Even: "Chẵn",
    Odd: "Lẻ",
    Dice: "Xí ngầu",
    Triple: "Tam Bảo",
    High: "Cao",
    Low: "Thấp",
    Black: "Đen",
    Red: "Đỏ",
    Joker: "Joker",

    //for history TabPane
    Result: "kết quả",
    Sum_Player: "Tổng Người chơi",
    Sum_Banker: "Tổng Nhà cái",
    SUM_OE: "Lẻ/Chẵn",
    SUM_BS: "Tài/Xỉu",
    CARD_HISTORY: "LỊCH SỬ RÚT BÀI",
    STATISTICS: "THỐNG KÊ",
    RED_BLACK: "ĐỎ/ĐEN",
    HI_LO: "LÊN/XUỐNG",
    Player: "Người chơi",
    Tie: "Hòa",
    Banker: "Nhà cái",

    PLACE_TICKET: "Cược",
    PLACE_FAIL: "Đặt cược thất bại!",
    PLACE_SUCCESS: "Đặt cược thành công!",
    ERROR_MIN_TO:
      "Rất tiếc, tiền cược của bạn không thế thấp hơn tiền cược tối thiểu!",
    ERROR_MAX_TO:
      "Rất tiếc, tiền cược của bạn không thế cao hơn tiền cược tối đa!",
    ERROR_MAX_DR: "Rất tiếc, bạn đã vượt quá Giới Hạn Cược Mỗi Vòng!",
    ERROR_MAX_BTDR: "Rất tiếc, loại cược đã vượt quá giới hạn cược mỗi vòng!",
    ERROR_NMB: "Rất tiếc, ngừng nhận cược.",
    ERROR_GAME_UA:
      "Đặt cược hiện không khả dụng. Vui lòng liên hệ với chúng tôi để biết thêm chi tiết, xin cảm ơn. ",
    ERROR_REBET_DONE: "Rất tiếc, bạn đã cược lại (các) cược trước đó.",
    ERROR_TO: "Rất tiếc, vui lòng nhập lại số tiền cược!",
    ERROR_XAMOUNT: "Rất tiếc, số dư tài khoản không đủ để đặt cược!",
    ERROR_206:
      "Đã đạt mức giới hạn thắng! Vui lòng liên hệ với Mạng Tổng Agent của bạn, xin cảm ơn.",
    ERROR_207:
      "Đã đạt mức giới hạn thua! Vui lòng liên hệ với Mạng Tổng Agent của bạn, xin cảm ơn.",
    ERROR_208:
      "Toàn khoản bị tạm treo! Vui lòng liên hệ với Mạng Tổng Agent của bạn, xin cảm ơn.",
    ERROR_209:
      "Tài khoản không hoạt động! Vui lòng liên hệ với Mạng Tổng Agent của bạn, xin cảm ơn.",
  },

  tai_xiu: {
    dicehistory: "LỊCH SỬ ĐỔ XÍ NGẦU",
    o1group: "Tài/Tam Bảo Bất Kỳ/Xỉu",
    o2group: "Tài/Tam Bảo Bất Kỳ/Xỉu",
    o3group: "Tài/Tam Bảo Bất Kỳ/Xỉu",
    o4group: "Lẻ/Chẵn",
    o5group: "Lẻ/Chẵn",

    o11group: "Số xác định",
    o21group: "Số xác định",
    o31group: "Số xác định",
    o41group: "Số xác định",
    o51group: "Số xác định",
    o61group: "Số xác định",
    o104group: "Tổng số xác định",
    o105group: "Tổng số xác định",
    o106group: "Tổng số xác định",
    o107group: "Tổng số xác định",
    o108group: "Tổng số xác định",
    o109group: "Tổng số xác định",
    o110group: "Tổng số xác định",
    o111group: "Tổng số xác định",
    o112group: "Tổng số xác định",
    o113group: "Tổng số xác định",
    o114group: "Tổng số xác định",
    o115group: "Tổng số xác định",
    o116group: "Tổng số xác định",
    o117group: "Tổng số xác định",

    o1: "Tài",
    o1_trend: "T",
    o2: "Xỉu",
    o2_trend: "X",
    o3: "Tam Bảo Bất Kỳ",
    o3_trend: "AT",
    o4: "Lẻ",
    o4_trend: "L",
    o5: "Chẵn",
    o5_trend: "C",

    o11: "Xí ngầu 1",
    o12: "2x Xí ngầu 1",
    o13: "3x Xí ngầu 1",
    o21: "Xí ngầu 2",
    o22: "2x Xí ngầu 2",
    o23: "3x Xí ngầu 2",
    o31: "Xí ngầu 3",
    o32: "2x Xí ngầu 3",
    o33: "3x Xí ngầu 3",
    o41: "Xí ngầu 4",
    o42: "2x Xí ngầu 4",
    o43: "3x Xí ngầu 4",
    o51: "Xí ngầu 5",
    o52: "2x Xí ngầu 5",
    o53: "3x Xí ngầu 5",
    o61: "Xí ngầu 6",
    o62: "2x Xí ngầu 6",
    o63: "3x Xí ngầu 6",

    o104: "4",
    o104_trend: "4",
    o105: "5",
    o105_trend: "5",
    o106: "6",
    o106_trend: "6",
    o107: "7",
    o107_trend: "7",
    o108: "8",
    o108_trend: "8",
    o109: "9",
    o109_trend: "9",
    o110: "10",
    o110_trend: "10",
    o111: "11",
    o111_trend: "11",
    o112: "12",
    o112_trend: "12",
    o113: "13",
    o113_trend: "13",
    o114: "14",
    o114_trend: "14",
    o115: "15",
    o115_trend: "15",
    o116: "16",
    o116_trend: "16",
    o117: "17",
    o117_trend: "17",

    "1_dice": "1 Xí ngầu",
    "2_dice": "2 Xí ngầu",
    "3_dice": "3 Xí ngầu",
  },

  hi_lo: {
    o1: "Lên",
    o1_trend: "L",
    o2: "Xuống",
    o2_trend: "X",
    o3: "Đỏ",
    o3_trend: "Đỏ",
    o4: "Đen",
    o4_trend: "Đen",
    o5: "Khoảng 2-9",
    o5_trend: "2-9",
    o6: "Khoảng JQKA",
    o6_trend: "JQKA",
    o7: "Khoảng KA",
    o7_trend: "KA",
    o101: "Lá A",
    o101_trend: "A",
    o102: "Lá 2",
    o102_trend: "2",
    o103: "Lá 3",
    o103_trend: "3",
    o104: "Lá 4",
    o104_trend: "4",
    o105: "Lá 5",
    o105_trend: "5",
    o106: "Lá 6",
    o106_trend: "6",
    o107: "Lá 7",
    o107_trend: "7",
    o108: "Lá 8",
    o108_trend: "8",
    o109: "Lá 9",
    o109_trend: "9",
    o110: "Lá J",
    o110_trend: "J",
    o111: "Lá Q",
    o111_trend: "Q",
    o112: "Lá K",
    o112_trend: "K",
    o113: "Lá Joker",
    o113_trend: "JK",

    //for new-bet-lot
    o1group: "Lên/Xuống",
    o2group: "Lên/Xuống",
    o3group: "Đỏ/Đen",
    o4group: "Đỏ/Đen",
    o5group: "Khoảng xác định",
    o6group: "Khoảng xác định",
    o7group: "Khoảng xác định",
    o101group: "Lá bài xác định",
    o102group: "Lá bài xác định",
    o103group: "Lá bài xác định",
    o104group: "Lá bài xác định",
    o105group: "Lá bài xác định",
    o106group: "Lá bài xác định",
    o107group: "Lá bài xác định",
    o108group: "Lá bài xác định",
    o109group: "Lá bài xác định",
    o110group: "Lá bài xác định",
    o111group: "Lá bài xác định",
    o112group: "Lá bài xác định",
    o113group: "Lá bài xác định",
  },

  domino: {
    result: "CHÍNH",
    main: "Chính",
    o1: "Người chơi",
    o1_trend: "Ng",
    o2: "Hòa",
    o2_trend: "/",
    o3: "Nhà cái",
    o3_trend: "Nh",

    o4: "Tài",
    o4_trend: "T",
    o5: "Xỉu",
    o5_trend: "X",
    o6: "Lẻ",
    o6_trend: "L",
    o7: "Chẵn",
    o7_trend: "C",
    o8: "Tài",
    o8_trend: "T",
    o9: "Xỉu",
    o9_trend: "X",
    o10: "Lẻ",
    o10_trend: "L",
    o11: "Chẵn",
    o11_trend: "C",
    o12_trend: "/",

    //for new-bet-lot
    o1group: "Người chơi/Hòa/Nhà cái",
    o2group: "Người chơi/Hòa/Nhà cái",
    o3group: "Người chơi/Hòa/Nhà cái",
    o4group: "Người chơi Tài/Xỉu",
    o5group: "Người chơi Tài/Xỉu",
    o6group: "Người chơi Lẻ/Chẵn",
    o7group: "Người chơi Lẻ/Chẵn",
    o8group: "Nhà cái Tài/Xỉu",
    o9group: "Nhà cái Tài/Xỉu",
    o10group: "Nhà cái Lẻ/Chẵn",
    o11group: "Nhà cái Lẻ/Chẵn",

    P_BS: "Ng T/X",
    P_OE: "Ng L/C",
    B_BS: "Nh T/X",
    B_OE: "Nh L/C",

    PLAYER: "Người Chơi",
    BANKER: "Nhà Cái",
    PLAYER_WIN: "Người Chơi Thắng",
    BANKER_WIN: "Nhà Cái Thắng",
    TIE: "Hòa",

    PLAYER_BIG: "Người Chơi Tài",
    PLAYER_SMALL: "Người Chơi Xỉu",
    PLAYER_ODD: "Người Chơi Lẻ",
    PLAYER_EVEN: "Người Chơi Chẵn",

    BANKER_BIG: "Nhà Cái Tài",
    BANKER_SMALL: "Nhà Cái Xỉu",
    BANKER_ODD: "Nhà Cái Lẻ",
    BANKER_EVEN: "Nhà Cái Chẵn",
  },

  fantan: {
    o1group: "Fan",
    o2group: "Ssh",
    o3group: "Kwok",
    o4group: "Nim",
    o5group: "Nga",
    o6group: "Lẻ/Chẵn",
    o7group: "Hòa",
    total: "Tổng cộng",
    odd: "Lẻ",
    even: "Chẵn",
    fan: "Fan",
    ssh: "Ssh",
    kwok: "Kwok",
    nga: "Nga",
    nim: "Nim",
    fan1: "Fan1",
    fan2: "Fan2",
    fan3: "Fan3",
    fan4: "Fan4",
    odd_trend: "L",
    even_trend: "C",
    result: "kết quả",
    history: "lịch sử",
    OE: "L/C",
  },

  maxracing: {
    o1: "C(vi)",
    o1_trend: "C(vi)",
    o2: "Big(vi)",
    o2_trend: "B(vi)",
    o3: "Small(vi)",
    o3_trend: "S(vi)",
    o4: "Odd(vi)",
    o4_trend: "O(vi)",
    o5: "Even(vi)",
    o5_trend: "E(vi)",
    o6: "Big(vi)",
    o6_trend: "B(vi)",
    o7: "Small(vi)",
    o7_trend: "S(vi)",
    o8: "Odd(vi)",
    o8_trend: "O(vi)",
    o9: "Even(vi)",
    o9_trend: "E(vi)",
    o10: "G1(vi)",
    o10_trend: "G1(vi)",
    o11: "G2(vi)",
    o11_trend: "G2(vi)",
    o12: "G3(vi)",
    o12_trend: "G3(vi)",
    o13: "G4(vi)",
    o13_trend: "G5(vi)",
    o14: "G5(vi)",
    o14_trend: "G5(vi)",

    //for new-bet-lot
    o1group: "Player/Tie/Banker",
    o2group: "Player/Tie/Banker",
    o3group: "Player/Tie/Banker",
    o4group: "Player Big/Small",
    o5group: "Player Big/Small",
    o6group: "Player Odd/Even",
    o7group: "Player Odd/Even",
    o8group: "Banker Big/Small",
    o9group: "Banker Big/Small",
    o10group: "Banker Odd/Even",
    o11group: "Banker Odd/Even",

    Champion: "Champion(vi)",
    C_BS: "C B/S(vi)",
    C_OE: "C O/E(vi)",
    S_BS: "S B/S(vi)",
    S_OE: "S O/E(vi)",
    Group: "Group(vi)",
    Place_champ: "Place Champion(vi)",
    Place_sum_champ: "Place Sum Champion(vi)",
    Runner_up: "Runner-up(vi)",
    Race_result: "Race Result(vi)",
  },
};

export default vi;
